import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import SimpleSpinner from '@Components/Results/utils/SimpleSpinner';

import './RsTable.theme.scss';

const RsTable = React.forwardRef((props, ref) => {
  const {
    isLoading,
    dataList,
    header = null,
    renderItem = () => null,
    className,
    containerClassName,
    children,
  } = props;

  return (
    <div ref={ref} className={cn('rs-table-container', containerClassName)}>
      <table className={cn('rs-table', className)}>
        <thead className="rs-table__header">
        {header}
        </thead>
        <tbody className="rs-table__body">
        {isLoading && (
          <tr>
            <td>
              <SimpleSpinner />
            </td>
          </tr>
        )}
        {dataList && dataList.map((projectVO, i) =>
          <React.Fragment key={`project-item-${i}`}>
            {renderItem(projectVO, i)}
          </React.Fragment>
        )}
        </tbody>
      </table>
      {children}
    </div>
  );
});

RsTable.defaultProps = {
  resize: true,
}

RsTable.propTypes = {
  isLoading: PropTypes.bool,
  dataList: PropTypes.array,
  header: PropTypes.node,
  renderItem: PropTypes.func,
  className: PropTypes.string,
  containerClassName: PropTypes.string,
};

export default RsTable;
